(() => {
  const configElement = document.getElementById('OnVoardConfig');

  if (!configElement) return;

  let config;

  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    return;
  }

  const productRootSelector = `product-info[data-product-id="${config.productId}"]`;
  let loaderPromise;
  let productPromise;
  let onvoardDataPromise;
  let formsObserver;

  function getProductRoot() {
    return document.querySelector(productRootSelector) || document;
  }

  function getForms() {
    return getProductRoot().querySelectorAll('.ov-app-back-in-stock-inline-form, [data-app="back-in-stock-inline-form"]');
  }

  function getDeferredFormsSlot() {
    return getProductRoot().querySelector('[data-onvoard-form-slot]');
  }

  function getDeferredFormsTemplate() {
    return getProductRoot().querySelector('template[data-onvoard-form-template]');
  }

  function getBuyButtons() {
    return getProductRoot().querySelector('.product-form__buttons');
  }

  function setRootState(state) {
    const productRoot = getProductRoot();
    if (!productRoot) return;
    productRoot.dataset.onvoardState = state;
  }

  function ensureQueue() {
    window.OnVoard =
      window.OnVoard ||
      function () {
        (window.OnVoard.q = window.OnVoard.q || []).push(arguments);
      };
  }

  function ensureFormsMounted() {
    if (getForms().length) return true;

    const slot = getDeferredFormsSlot();
    const template = getDeferredFormsTemplate();

    if (!slot || !template) return false;

    slot.appendChild(template.content.cloneNode(true));
    slot.dataset.onvoardFormsMounted = 'true';
    return true;
  }

  function setFormsVisible(visible) {
    getForms().forEach((form) => {
      form.style.setProperty('display', visible ? 'block' : 'none', 'important');
    });
  }

  function setBuyButtonsVisible(visible) {
    const buyButtons = getBuyButtons();

    if (!buyButtons) return;

    buyButtons.style.setProperty('display', visible ? 'block' : 'none', 'important');
  }

  function syncCurrentVisibility() {
    const state = getProductRoot().dataset.onvoardState;

    if (state === 'notify') {
      setBuyButtonsVisible(false);
      setFormsVisible(true);
      return;
    }

    if (state === 'buy') {
      setBuyButtonsVisible(true);
      setFormsVisible(false);
    }
  }

  function ensureFormsObserver() {
    const productRoot = getProductRoot();

    if (!productRoot || formsObserver) return;

    formsObserver = new MutationObserver(() => {
      syncCurrentVisibility();
    });

    formsObserver.observe(productRoot, {
      childList: true,
      subtree: true,
    });
  }

  function loadOnvoardScript() {
    if (loaderPromise) return loaderPromise;

    const existingScript = document.querySelector('script[data-onvoard-loader], script[src*="scripts.onvoard.com/apps/loader.js"]');

    if (existingScript) {
      loaderPromise = Promise.resolve(existingScript);
      return loaderPromise;
    }

    loaderPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      const firstScript = document.getElementsByTagName('script')[0];

      script.type = 'text/javascript';
      script.async = true;
      script.dataset.onvoardLoader = 'true';
      script.src = `https://scripts.onvoard.com/apps/loader.js?shop=${encodeURIComponent(config.shop.myshopify_domain)}`;
      script.onload = () => resolve(script);
      script.onerror = reject;

      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        document.head.appendChild(script);
      }
    });

    return loaderPromise;
  }

  function loadProductData() {
    if (productPromise) return productPromise;

    productPromise = fetch(config.product_json_url, { credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error(`OnVoard product request failed with ${response.status}`);
        return response.json();
      })
      .catch(() => null);

    return productPromise;
  }

  function ensureOnvoardData() {
    if (window.OnVoardData) return Promise.resolve(window.OnVoardData);
    if (onvoardDataPromise) return onvoardDataPromise;

    onvoardDataPromise = loadProductData().then((product) => {
      window.OnVoardData = {
        ecommerce_platform: 'shopify',
        page_type: 'product',
        template: 'product',
        product,
        customer: config.customer || {},
        shop: config.shop,
      };

      return window.OnVoardData;
    });

    return onvoardDataPromise;
  }

  async function syncVariant(variant) {
    if (!variant) return;

    if (variant.available) {
      setRootState('buy');
      setBuyButtonsVisible(true);
      setFormsVisible(false);
      return;
    }

    setRootState('notify');
    setBuyButtonsVisible(false);
    ensureFormsMounted();

    ensureQueue();
    await ensureOnvoardData();
    try {
      await loadOnvoardScript();
    } catch (error) {
      setBuyButtonsVisible(true);
      setFormsVisible(false);
      return;
    }

    window.OnVoard('back_in_stock_inline_form', 'setVariantId', String(variant.id));

    setFormsVisible(true);
  }

  document.addEventListener('DOMContentLoaded', () => {
    ensureFormsObserver();
    syncVariant(config.initial_variant);
  });

  document.addEventListener('variant:changed', (event) => {
    if (!event.detail || !event.detail.variant) return;
    syncVariant(event.detail.variant);
  });
})();
